/**
 * 验证表单
 *
 * @param {表单实例} form
 */
import { getStore } from "@/util/store.js";

export const validForm = form => {
  let flag;

  form.validate(valid => {
    flag = valid;
  });
  return flag;
};

export const serialize = data => {
  const list = [];
  Object.keys(data).forEach(ele => {
    list.push(`${ele}=${data[ele]}`);
  });
  return list.join("&");
};

export const getUserInfo = () => {
  return getStore({ name: "userInfo", timer: 1200 }); // getStore 使用样例
};

export const getApiPath = () => {
  return "/apis";
};

export const getProjectPath = () => {
  let projectPath;
  if (window.location.pathname) {
    projectPath = window.location.pathname.split("/")[1];
  }

  if (projectPath) {
    return "/" + projectPath;
  } else {
    return "";
  }
};

export const getAccount = () => {
  let userInfo = getStore({ name: "userInfo", timer: 1200 }); // getStore 使用样例
  if (userInfo && userInfo.elsAccount) {
    return userInfo;
  }
};

export const removeArrItem = (removeItem, array, prop = "reviewCode") => {
  if (array && array.length > 0) {
    let itemIndex = null;
    array.map((item, index) => {
      if (item[prop] === removeItem[prop]) {
        itemIndex = index;
      }
    });
    if (itemIndex !== null) {
      array.splice(itemIndex, 1);
    }
  }
  return array;
};

export const getLocalToken = () => {
  // const params = {
  //   elsAccount: '307000',
  //   elsSubAccount: '1001',
  //   elsSubAccountPassword: md5('123')
  // };
  // let prefix = getApiPath();
  // login(params, prefix).then((res) => {
  //   setToken(res.data.data.token);
  //   let params2 = {
  //     name: 'userInfo',
  //     content: {
  //       elsAccount: params.elsAccount,
  //       elsSubAccount: params.elsSubAccount,
  //       token: res.data.data.token
  //     }
  //   };
  //   setStore(params2);
  // });
};

export function unique(arr) {
  return Array.from(new Set(arr));
}
export function uniqueArr(arr1, arr2) {
  // 合并两个数组
  arr1.push(...arr2); // 或者arr1 = [...arr1,...arr2]
  // 去重
  let arr3 = Array.from(new Set(arr1)); // let arr3 = [...new Set(arr1)]
  return arr3;
}

/**
 * 跨应用路由跳转
 * @param {String} href url地址
 * @param {Object} stateObj 状态参数 可以通过history.state读取
 * @param {String} title 标题 暂时没有用
 */

export function routerGo(href = "/", title = null, stateObj = {}) {
  // this.$root.$emit("openTag", {
  //   label: title,
  //   value: href,
  // });
  // if(href === '/vendor/#/admittance'){
  //   href = '/vendor/#/wel'
  // }
  window.history.pushState(stateObj, title, href);
}

export default {
  routerGo // 跨应用路由跳转
};
